var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-chip',_vm._g(_vm._b({attrs:{"color":_vm.color || 'secondary',"dark":"","text":_vm.value}},'base-chip',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }